import RouteParent from 'js/router/route-parent'
import LogsLoginIndex from 'js/pages/logs-login/index.js'

export default [
  {
    path: '/logs-login',
    component: RouteParent,
    meta: {
      auth: true
    },
    children: [
      {
        path: '',
        name: 'logs-login-index',
        component: LogsLoginIndex,
        meta: {
          auth: true,
          permit: ['MANAGE_LAIA_ADMIN']
        }
      }
    ]
  }
]
